import { render, staticRenderFns } from "./TicketComments.vue?vue&type=template&id=c09225fa&scoped=true&"
import script from "./TicketComments.vue?vue&type=script&lang=js&"
export * from "./TicketComments.vue?vue&type=script&lang=js&"
import style0 from "./TicketComments.vue?vue&type=style&index=0&id=c09225fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c09225fa",
  null
  
)

export default component.exports